module.exports = new __parcel__URL__("BricksInMotion.2bdd2cb2.avif").toString();